import type { StaffNotification } from '@nucleus-commerce/api-client/admin';

/** Kinds about an auction: they open the auction, whose page links on to the winner's order. */
const AUCTION_KINDS: ReadonlySet<string> = new Set(['auction_sold', 'auction_no_sale']);

/**
 * Where an alert leads, built from the notification's own data: the run of a schedule (an
 * organisation-level alert with no store), the auction for the auction kinds, otherwise the order
 * page of its store. The backend's `link` is written for another URL shape and is ignored; data
 * is the contract.
 */
export function notificationTarget(
  notification: Pick<StaffNotification, 'storeId' | 'data'> & { kind?: string },
): string | null {
  const { scheduleId, runId } = notification.data;
  if (notification.kind === 'schedule_run' && typeof scheduleId === 'string' && scheduleId !== '') {
    const run =
      typeof runId === 'string' && runId !== '' ? `?run=${encodeURIComponent(runId)}` : '';
    return `/org/schedules/${encodeURIComponent(scheduleId)}${run}`;
  }
  if (!notification.storeId) return null;
  const { auctionId, orderId } = notification.data;
  if (
    notification.kind !== undefined &&
    AUCTION_KINDS.has(notification.kind) &&
    typeof auctionId === 'string' &&
    auctionId !== ''
  ) {
    return `/s/${notification.storeId}/auctions/${auctionId}`;
  }
  if (typeof orderId !== 'string' || orderId === '') return null;
  return `/s/${notification.storeId}/orders/${orderId}`;
}
